
import './App.css';
import HomeMain from './Pages/Home/HomeMain';
import { Route ,Router,Routes} from 'react-router-dom';
import ServicesMain from './Pages/Services/ServicesMain';
import Login from './Pages/Auth/Login';
import Register from './Pages/Auth/Register';
import Profile from './Pages/Auth/Profile';
import ServiceDetail from './Pages/Services/ServiceDetail';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<HomeMain/>}/>
        <Route path='/login' element={<Login/>}/>
           <Route path='/profile' element={<Profile/>}/>
         <Route path='/register' element={<Register/>}/>
        <Route path='/services' element={<ServicesMain/>}/>
        <Route path='/service/:id' element={<ServiceDetail/>}/>
      </Routes>

    </div>
  );
}

export default App;
